// extracted by css-extract-rspack-plugin
export default {"hideLeadingVisual":"PullRequestCodeButton-module__hideLeadingVisual__wxPft"};